var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPosCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 185,
    viewBox: "0 0 246 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5438_171211)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 185,
    fill: "url(#paint0_linear_5438_171211)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter0_ddd_5438_171211)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: -0.5,
    r: 210.5,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter1_ddd_5438_171211)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 134,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter2_ddd_5438_171211)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 74,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.971 160.611C171.971 161.953 171.726 162.925 171.242 163.501C170.951 163.799 170.596 164.029 170.204 164.173C169.811 164.318 169.391 164.373 168.973 164.336C168.553 164.377 168.128 164.321 167.734 164.171C167.339 164.021 166.986 163.782 166.702 163.473C166.161 162.618 165.911 161.615 165.989 160.61V147.691H160.055V160.907C160.055 163.521 160.843 165.545 162.397 166.922C163.938 168.287 166.15 168.979 168.973 168.979C171.882 168.979 174.12 168.274 175.625 166.882C177.13 165.49 177.907 163.468 177.907 160.893V147.691H171.971V160.611ZM172.801 148.51H177.077V160.896C177.077 163.236 176.398 165.049 175.058 166.287C173.719 167.524 171.665 168.163 168.974 168.163C166.362 168.163 164.336 167.54 162.952 166.315C161.58 165.1 160.885 163.281 160.885 160.91V148.51H165.16V160.611C165.078 161.796 165.388 162.976 166.044 163.972C166.402 164.384 166.855 164.705 167.364 164.911C167.873 165.116 168.424 165.2 168.972 165.155C169.512 165.196 170.054 165.115 170.557 164.919C171.06 164.723 171.512 164.417 171.878 164.024C172.489 163.297 172.799 162.148 172.799 160.611L172.801 148.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.619 169H211.192V164.261H202.527V159.913H210.512V155.175H202.527V152.41H211.193V147.671H196.62L196.619 169ZM197.448 148.501H210.364V151.582H201.697V156.001H209.682V159.082H201.697V165.087H210.364V168.168H197.448V148.501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.518 164.886H219.206C220.565 164.886 221.472 164.877 221.978 164.859C222.566 164.832 223.144 164.697 223.682 164.462C224.195 164.259 224.624 163.89 224.897 163.415C225.149 162.956 225.277 162.44 225.27 161.918C225.3 161.32 225.139 160.728 224.81 160.225C224.472 159.784 224.005 159.456 223.472 159.286C223.017 159.135 222.54 159.06 222.06 159.064C221.513 159.051 220.777 159.044 219.873 159.044H218.516L218.518 164.886ZM219.348 159.863H219.875C220.769 159.863 221.498 159.87 222.042 159.883C222.431 159.878 222.818 159.936 223.188 160.054C223.565 160.169 223.896 160.395 224.139 160.701C224.364 161.066 224.471 161.491 224.443 161.918C224.45 162.302 224.358 162.681 224.174 163.02C223.989 163.336 223.7 163.579 223.354 163.71C222.91 163.905 222.433 164.017 221.947 164.041C221.467 164.057 220.616 164.066 219.346 164.067L219.348 159.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.754 158.701C229.112 158.014 228.306 157.496 227.408 157.195C227.984 156.819 228.471 156.326 228.836 155.748C229.38 154.881 229.661 153.879 229.645 152.86C229.661 151.998 229.458 151.146 229.056 150.381C228.642 149.639 228.017 149.033 227.258 148.638C226.544 148.25 225.765 147.99 224.958 147.871C223.812 147.734 222.658 147.675 221.504 147.695H213.91V163.645C213.656 163.734 213.441 163.908 213.303 164.136C213.165 164.365 213.113 164.634 213.155 164.897C213.197 165.16 213.332 165.4 213.534 165.575C213.737 165.751 213.996 165.851 214.265 165.858C214.535 165.865 214.799 165.779 215.011 165.614C215.223 165.45 215.369 165.217 215.426 164.957C215.482 164.696 215.444 164.425 215.319 164.189C215.194 163.954 214.989 163.769 214.74 163.666V148.52H221.504C222.617 148.5 223.73 148.556 224.836 148.687C225.546 148.792 226.233 149.021 226.862 149.363C227.48 149.682 227.99 150.174 228.328 150.777C228.663 151.42 228.831 152.136 228.816 152.86C228.83 153.722 228.595 154.57 228.136 155.304C227.694 156.001 227.042 156.545 226.272 156.86L226.019 156.966V157.688L226.348 157.757C227.419 157.952 228.399 158.478 229.146 159.26C229.864 160.108 230.23 161.194 230.169 162.298C230.188 163.159 230.007 164.013 229.639 164.794C229.304 165.482 228.816 166.087 228.211 166.563C227.51 167.122 226.703 167.536 225.837 167.781C224.734 168.052 223.599 168.177 222.462 168.15H214.379V168.982H222.46C223.672 169.009 224.881 168.874 226.056 168.582C227.028 168.308 227.933 167.844 228.719 167.218C229.422 166.665 229.988 165.963 230.378 165.164C230.802 164.269 231.013 163.289 230.994 162.301C231.059 160.989 230.616 159.702 229.754 158.701V158.701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.632 168.151H180.893V148.52H185.169V165.076H188.67C188.768 165.257 188.914 165.408 189.092 165.513C189.27 165.618 189.474 165.674 189.682 165.674C189.89 165.674 190.094 165.618 190.272 165.513C190.451 165.408 190.597 165.257 190.695 165.076L190.772 164.893C190.812 164.779 190.834 164.66 190.835 164.539C190.835 164.263 190.734 163.997 190.55 163.79C190.366 163.583 190.112 163.449 189.835 163.413C189.558 163.378 189.278 163.443 189.046 163.597C188.814 163.75 188.647 163.982 188.576 164.248H186V147.692H180.065V168.982H194.462V164.251H193.633L193.632 168.151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.662 148.512C155.75 148.765 155.924 148.978 156.155 149.117C156.386 149.255 156.658 149.31 156.926 149.271C157.193 149.232 157.438 149.102 157.618 148.903C157.798 148.705 157.902 148.45 157.912 148.184C157.922 147.918 157.838 147.656 157.673 147.445C157.508 147.234 157.274 147.086 157.01 147.028C156.746 146.969 156.47 147.004 156.23 147.125C155.989 147.246 155.799 147.447 155.693 147.691H147.308V152.167H151.962V159.836C151.962 160.533 151.951 161.181 151.929 161.761C151.919 162.24 151.811 162.712 151.614 163.149C151.444 163.524 151.145 163.827 150.771 164.006C150.176 164.26 149.529 164.373 148.882 164.338C148.344 164.353 147.806 164.289 147.288 164.148C146.854 164.012 146.431 163.863 146.033 163.705L145 163.671V168.506L145.329 168.575C146.035 168.718 146.749 168.818 147.467 168.874C148.267 168.943 149.134 168.977 150.042 168.977C151.169 168.993 152.293 168.841 153.374 168.525C154.326 168.236 155.203 167.745 155.943 167.085C156.599 166.502 157.105 165.773 157.418 164.959C157.739 164.122 157.901 163.235 157.896 162.34V152.092H157.066V162.342C157.072 163.135 156.928 163.923 156.644 164.665C156.377 165.359 155.946 165.981 155.387 166.479C154.736 167.058 153.964 167.49 153.125 167.744C152.125 168.035 151.085 168.175 150.042 168.158C149.152 168.158 148.311 168.125 147.539 168.059C146.913 168.005 146.34 167.934 145.83 167.839V164.51C146.216 164.661 146.622 164.803 147.036 164.933C147.636 165.1 148.259 165.178 148.882 165.162C149.662 165.201 150.441 165.055 151.153 164.736C151.692 164.473 152.121 164.033 152.367 163.492C152.609 162.958 152.741 162.381 152.754 161.797C152.777 161.211 152.788 160.552 152.788 159.839V151.346H148.137V148.512H155.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.703 156.395C223.142 156.167 223.489 155.798 223.687 155.349C223.893 154.876 223.996 154.366 223.988 153.852C224.016 153.265 223.887 152.681 223.616 152.158C223.367 151.739 222.987 151.41 222.533 151.22C222.171 151.071 221.782 150.996 221.389 150.998C220.948 150.985 220.35 150.979 219.618 150.979H218.519V156.82H219.076C220.177 156.82 220.911 156.811 221.322 156.793C221.806 156.764 222.278 156.628 222.703 156.395V156.395ZM219.191 156.001V151.797H219.618C220.342 151.797 220.932 151.804 221.373 151.817C221.691 151.813 222.006 151.871 222.301 151.988C222.621 152.117 222.891 152.344 223.07 152.635C223.256 153.013 223.341 153.432 223.317 153.852C223.324 154.23 223.25 154.605 223.1 154.953C222.966 155.252 222.732 155.496 222.437 155.644C222.087 155.836 221.697 155.949 221.297 155.974C220.908 155.991 220.219 156 219.189 156.001H219.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9346 90.4874C21.7096 88.7374 20.9346 86.7124 20.9346 84.0124C20.9346 83.0874 21.0096 82.2374 21.1596 81.4874H24.8596L21.7596 73.5374C24.1596 71.4624 26.5596 69.9874 29.4346 69.9874C32.3346 69.9874 34.8346 71.4624 37.1346 73.5624L34.1346 81.4874H38.7096V84.9874H24.4846V85.3624C24.4846 86.5874 24.8346 87.7874 25.6596 89.2124L22.9346 90.4874ZM29.4346 73.6874C28.0596 73.6874 26.9596 74.1124 25.6846 75.0374L27.9596 81.4874H30.9596L33.2346 75.0124C31.8346 74.0624 30.8596 73.6874 29.4346 73.6874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2207 84.9874V81.4874H43.4457V70.9124H46.9457V81.4874H51.5457V84.9874H38.2207ZM47.7207 90.3124C46.6707 90.3124 45.7707 89.6874 45.7707 88.5374C45.7707 87.4624 46.6207 86.7374 47.7207 86.7374C48.8457 86.7374 49.6707 87.4624 49.6707 88.5374C49.6707 89.6874 48.7707 90.3124 47.7207 90.3124ZM42.2957 90.3124C41.2457 90.3124 40.3457 89.6874 40.3457 88.5374C40.3457 87.4624 41.1957 86.7374 42.2957 86.7374C43.3957 86.7374 44.2457 87.4624 44.2457 88.5374C44.2457 89.6874 43.3457 90.3124 42.2957 90.3124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0381 84.9874V81.4874H54.1381V70.9124H57.6381V81.4874H60.3131V84.9874H51.0381ZM55.8881 90.3124C54.7881 90.3124 53.8381 89.6624 53.8381 88.4374C53.8381 87.3374 54.7381 86.5874 55.8881 86.5874C57.0631 86.5874 57.9381 87.3374 57.9381 88.4374C57.9381 89.6624 56.9881 90.3124 55.8881 90.3124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8271 84.9874V81.4874H62.2771V64.7124H65.7771V84.9874H59.8271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9141 84.9874V64.7124H74.4141V84.9874H70.9141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2273 84.9874V81.4874H86.6773V64.7124H90.1773V72.1624H97.8023C100.052 72.1624 101.752 72.7124 103.002 74.0374C104.052 75.1624 104.452 77.0124 104.452 79.0624V84.9874H84.2273ZM98.1523 75.6374H90.1773V81.4874H100.952V78.9124C100.952 77.9124 100.727 77.1874 100.277 76.6124C99.8523 76.0624 99.0523 75.6374 98.1523 75.6374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 84.9874V64.7124H112.5V81.4874H115.7V84.9874H109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.198 84.9874V81.4874H118.548C117.823 80.5374 117.348 79.3624 117.348 77.9374C117.348 73.5374 120.748 70.9124 125.748 70.9124H129.873V81.4874H132.173V84.9874H115.198ZM120.848 77.9374C120.848 79.4624 121.598 80.6874 122.748 81.4874H126.373V74.4124H124.898C122.873 74.4124 120.848 75.6374 120.848 77.9374ZM127.448 68.7874C126.398 68.7874 125.498 68.1624 125.498 66.9874C125.498 65.9374 126.348 65.2124 127.448 65.2124C128.573 65.2124 129.398 65.9374 129.398 66.9874C129.398 68.1624 128.498 68.7874 127.448 68.7874ZM122.023 68.7874C120.973 68.7874 120.073 68.1624 120.073 66.9874C120.073 65.9374 120.923 65.2124 122.023 65.2124C123.123 65.2124 123.973 65.9374 123.973 66.9874C123.973 68.1624 123.073 68.7874 122.023 68.7874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.453 68.7874C135.353 68.7874 134.403 68.1374 134.403 66.9124C134.403 65.8124 135.303 65.0624 136.453 65.0624C137.628 65.0624 138.503 65.8124 138.503 66.9124C138.503 68.1374 137.553 68.7874 136.453 68.7874ZM131.678 84.9874V81.4874H134.778V70.9124H138.278V84.9874H131.678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0346 112.412H26.0346V119.987H22.4346V99.7124H30.0346C35.2096 99.7124 37.4596 102.737 37.4596 105.912C37.4596 109.287 35.0596 112.412 30.0346 112.412ZM29.2596 103.062H26.0346V109.062H29.2596C31.8846 109.062 33.6596 108.337 33.6596 105.987C33.6596 103.987 32.2346 103.062 29.2596 103.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6154 109.812C60.6154 115.737 56.2654 120.287 50.0904 120.287C43.9154 120.287 39.5654 115.737 39.5654 109.812C39.5654 103.912 43.9154 99.3374 50.0904 99.3374C56.2654 99.3374 60.6154 103.912 60.6154 109.812ZM56.8154 109.812C56.8154 105.562 53.9404 102.762 50.0904 102.762C46.2654 102.762 43.3904 105.562 43.3904 109.812C43.3904 114.062 46.2654 116.862 50.0904 116.862C53.9404 116.862 56.8154 114.062 56.8154 109.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9152 115.312C65.3402 116.212 67.7652 116.887 69.8652 116.887C72.3152 116.887 74.1902 116.087 74.1902 114.212C74.1902 112.512 72.6652 111.937 70.3402 111.362L68.6652 110.937C64.9902 110.037 63.0902 107.887 63.0902 104.887C63.0902 101.587 66.0402 99.3374 70.4402 99.3374C72.9652 99.3374 75.8152 100.112 77.5402 101.162L76.1152 104.337C74.6402 103.387 72.3652 102.762 70.4152 102.762C68.4902 102.762 66.8152 103.512 66.8152 104.962C66.8152 106.287 67.7902 107.012 70.0402 107.587L71.7402 108.012C75.1652 108.862 77.9902 110.612 77.9902 114.237C77.9902 118.137 74.5652 120.287 69.9652 120.287C67.1402 120.287 64.2152 119.537 62.4902 118.487L63.9152 115.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.849 -14.9819C193.941 23.4956 209.44 104.179 302.376 120.366M302.376 120.366C302.772 120.435 303.169 120.502 303.569 120.569C397.565 136.27 341.938 126.975 302.376 120.366Z",
    stroke: "white",
    strokeWidth: 1.57009
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M149.627 -1.96711C165.56 33.274 219.464 95.2776 307.969 62.6286M307.969 62.6286C308.346 62.4894 308.724 62.3485 309.103 62.2058C398.281 28.6048 345.504 48.4873 307.969 62.6286Z",
    stroke: "white",
    strokeWidth: 1.57009
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_5438_171211",
    x: -284,
    y: -234,
    width: 569,
    height: 569,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171211"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171211",
    result: "effect2_dropShadow_5438_171211"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171211",
    result: "effect3_dropShadow_5438_171211"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171211",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_5438_171211",
    x: -208,
    y: -157,
    width: 416,
    height: 416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171211"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171211",
    result: "effect2_dropShadow_5438_171211"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171211",
    result: "effect3_dropShadow_5438_171211"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171211",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddd_5438_171211",
    x: -148,
    y: -97,
    width: 296,
    height: 296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171211"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171211",
    result: "effect2_dropShadow_5438_171211"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171211",
    result: "effect3_dropShadow_5438_171211"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171211",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5438_171211",
    x1: 0,
    y1: 0,
    x2: 246,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#FFAA63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784375,
    stopColor: "#fe6a00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5438_171211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 185,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosCard);
export default __webpack_public_path__ + "static/media/posCard.08b992eca5d36797e4dfe7fba35f0c03.svg";
export { ForwardRef as ReactComponent };